<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="main-title">{{ title }}</div>
        <!-- <div v-if="deadline" class="main-sub">提交截止日期：{{ deadline }}</div> -->
        <div class="main-sub" v-html="content.content"></div>
        <div class="main-tips" v-if="content.id == 22">
          <div class="tips-left">
            <div class="tips-title red1">受邀观众礼遇</div>
            <p>
              通过邀请函注册的观众， 电子票将显示为展会“<span class="red1"
                >特邀嘉宾</span
              >”
            </p>
            <div class="tips-title">
              持<span class="red1">特邀嘉宾</span>电子票
            </div>
            <p>1、可走展会VIP通道快速入场</p>
            <p>2、可进入展会VIP贵宾休息区</p>
          </div>
          <div class="tips-right">
            <div class="tips-title red1">展商礼遇</div>
            <p>
              1、邀请客户成功注册超过<span class="red1">10</span
              >人，将获得精美礼品1份（展会现场领取）
            </p>
            <p>
              2、邀请榜<span class="red1">TOP5</span>企业将额外获得神秘大礼！
            </p>
          </div>
        </div>
        <div class="con-list pd flex">
          <div
            class="con-item"
            :class="{
              known: item.is_skip == 1 && item.is_verify == 0,
              skip: item.is_skip == 1 && item.is_verify == 1,
              next: item.is_skip == 0 && item.is_verify == 1,
              pc: item.mark == 'PcInvitation',
              nhne:
                item.mark == 'NhneInvitation' || item.mark == 'CphiInvitation',
            }"
            v-for="(item, index) in list"
            :key="index"
            @click="toLink(item.link_url, item.mark, item.link_type)"
          >
            <div class="con-top flex">
              <el-image
                class="icon-img"
                v-if="item.icon"
                :src="item.icon"
              ></el-image>
              {{ item.name }}
            </div>
            <div v-if="item.deadline" class="tjtime">
              提交截止日期：{{ item.deadline }}
            </div>
            <div class="tjtime" v-if="item.name == '参展须知'">
              有问题可联系：010-68512208
            </div>
            <div class="con-bottom flex">
              <div>
                <div class="con-status read" v-if="item.action == 2">
                  已完成
                </div>
                <div class="con-status warning" v-if="item.action == 1">
                  跳过
                </div>
                <div class="con-status uncompleted" v-if="item.action == 0">
                  <!-- {{ item.is_verify == 0 ? '未读' : '未完成'}} -->
                  未完成
                </div>
                <div class="con-status warning" v-if="item.action == 3">
                  审核中
                </div>
                <div class="con-status read" v-if="item.action == 4">
                  已完成
                </div>
                <div class="con-status uncompleted" v-if="item.action == 5">
                  未通过
                </div>
              </div>
              <div class="con-more">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="conf-btn flex">
          <!-- 可跳过需要验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 1">
            <div class="btn" @click="next('skip')">跳过</div>
            <div class="btn next-btn" @click="next('next')">下一步</div>
          </template>
          <!-- 可跳过无需验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 0">
            <!-- 24.9.1 已知悉改成下一步 dxm-->
            <div
              class="btn next-btn"
              @click="next('known')"
              v-if="detail.is_skip == 1 && detail.is_verify == 0"
            >
              下一步
            </div>
          </template>
          <!-- 不可跳过需要验证 -->
          <template v-if="detail.is_skip == 0 && detail.is_verify == 1">
            <div class="btn next-btn" @click="next('next')">下一步</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail, skipOrReadStep, getmyMenu } from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "conference",
  data() {
    return {
      loading: false,
      active: -1,
      content: {
        content: "",
      },
      list: [],
      detail: {},
      title: "",
      deadline: "",
    };
  },
  watch: {
    $route(to, from) {
      window.location.reload();
    },
  },
  mounted() {
    this.getMenu();
    //获取详情
    let id = this.$route.query.id;
    this.getContent(id);
  },
  created() {},
  methods: {
    getMenu() {
      let that = this;
      getmyMenu()
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            console.log(data, "data");
            this.stepMenuList = data;
            let stepMenuList = data;
            var index = stepMenuList.findIndex(function (item) {
              if (that.$route.query.id != undefined) {
                return (
                  item.link_url == "conference" &&
                  item.id == that.$route.query.id
                );
              } else {
                return item.link_url == "conference";
              }
            });
            that.detail = stepMenuList[index];
            if (
              stepMenuList[index].children &&
              stepMenuList[index].children.length > 0
            ) {
              that.list = stepMenuList[index].children;
            }
            that.title = stepMenuList[index].name;
            if (that.title == "邀请函管理") {
              that.title = "客户邀请";
            }
            that.active = index;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //  获取内容
    getContent(id) {
      getDetail({ id })
        .then((res) => {
          console.log(res, "======菜单进度");
          if (res.data.code == 1) {
            let { data } = res.data;
            this.content = data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 跳转页面
    toLink(path, mark, link_type) {
      if (link_type == 2) {
        window.open(path, "_blank");
        this.skipOrReadStep(2, mark);
      } else {
        this.$router.push({
          path,
          query: {
            mark,
          },
        });
      }
    },
    // 跳转下一步
    next(type) {
      if (type == "next") {
        //下一步
        //不是2 3 4 5，且需要验证的时候 不能下一步
        // if (this.detail.action == 1 || this.detail.action == 4) {
        //   this.toPath();
        // } else {
        //   this.$message.warning("请完善信息!");
        // }
        if (this.detail.action >= 2) {
          this.toPath();
        } else if (this.detail.is_verify == 1) {
          this.$message.warning("请完善信息!");
        } else {
          this.toPath();
        }
      } else if (type == "skip") {
        //跳过
        this.skipOrReadStep(1, this.detail.mark);
      } else if (type == "known") {
        //已知悉
        this.skipOrReadStep(2, this.detail.mark);
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action, mark) {
      let data = {
        action,
        mark,
      };
      skipOrReadStep(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success("操作成功");
            if (mark !== "ExNotice") {
              this.toPath();
            } else {
              this.getMenu();
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toPath() {
      this.active = this.active + 1;
      let { link_url, id } = this.stepMenuList[this.active];
      if (link_url == "conference") {
        this.$router.push({
          path: link_url,
          query: {
            id,
          },
        });
      } else {
        this.$router.push({
          path: link_url,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tjtime {
  margin-top: 12px !important;
}
.main-sub {
  // width: 946px;
}
.main-tips {
  display: flex;
  flex-wrap: wrap;
  color: #646889;
  line-height: 30px;
  .tips-left {
    margin-right: 30px;
  }
  .tips-title {
    font-size: 20px;
    margin-top: 10px;
  }
  p {
    font-size: 16px;
  }
}
.red {
  color: #ff005a;
}
.red1{
  color: red;
}
.con-bottom {
  // width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 42px;
  z-index: 9;
  position: relative;
}
.con-list {
  width: 100%;
  margin-top: 50px;
  flex-wrap: wrap;
  flex-direction: row;
  background: #fff;
  padding: 30px 0 300px 20px;
  border-radius: 8px;
  box-sizing: border-box;
  .known {
    &::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 15px;
      z-index: 1;
      background: linear-gradient(90deg, #57ccf1 0%, #2e81eb 100%);
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 50%;
      width: 80%;
      height: 20px;
      z-index: 1;
      transform: translateX(-50%);
      background: linear-gradient(90deg, #57ccf1 0%, #2e81eb 100%);
      border-radius: 8px;
      filter: blur(12px);
    }
  }
  .skip {
    &::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 15px;
      z-index: 1;
      background: linear-gradient(90deg, #ffdf69 0%, #f7971e 100%);
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 50%;
      width: 80%;
      height: 20px;
      z-index: 1;
      transform: translateX(-50%);
      background: linear-gradient(90deg, #ffdf69 0%, #f7971e 100%);
      border-radius: 8px;
      filter: blur(12px);
    }
  }
  .next {
    &::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 15px;
      z-index: 1;
      background: linear-gradient(90deg, #f4685c 0%, #e43a15 100%);
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 50%;
      width: 80%;
      height: 20px;
      z-index: 1;
      transform: translateX(-50%);
      background: linear-gradient(90deg, #f4685c 0%, #e43a15 100%);
      border-radius: 8px;
      filter: blur(12px);
    }
  }
  .pc {
    &::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 15px;
      z-index: 1;
      background: linear-gradient(90deg, #f76a7b 0%, #fa0524 100%) !important;
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 50%;
      width: 80%;
      height: 20px;
      z-index: 1;
      transform: translateX(-50%);
      background: linear-gradient(90deg, #f76a7b 0%, #fa0524 100%) !important;
      border-radius: 8px;
      filter: blur(12px);
    }
  }
  .nhne {
    &::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 15px;
      z-index: 1;
      background: linear-gradient(90deg, #baf254 0%, #9fd43f 100%) !important;
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 50%;
      width: 80%;
      height: 20px;
      z-index: 1;
      transform: translateX(-50%);
      background: linear-gradient(90deg, #baf254 0%, #9fd43f 100%) !important;
      border-radius: 8px;
      filter: blur(12px);
    }
  }
  .con-item {
    flex-direction: column;
    width: 263px;
    // height: 113px;
    margin-right: 22px;
    // background: linear-gradient(90deg, #87EECE 0%, #58D6D8 100%);
    border-radius: 15px;
    box-sizing: border-box;
    padding: 33px 33px 33px 23px;
    flex-wrap: wrap;
    position: relative;
    cursor: pointer;
    margin-bottom: 20px;

    .con-status {
      width: 68px;
      height: 22px;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      background: #fff;
      border-radius: 7px;
    }
    .read {
      color: #1ac484 !important;
    }
    .uncompleted {
      color: #ff4d64 !important;
    }
    .warning {
      color: #ffb800 !important;
    }
    .con-top {
      font-size: 20px;
      font-weight: 600;
      color: #fff;
      align-items: center;
      align-self: flex-start;
      z-index: 9;
      position: relative;
      .icon-img {
        width: 48px;
        height: 48px;
        margin-right: 15px;
      }
    }
    .con-sub {
      width: 100%;
      font-size: 15px;
      color: #fff;
    }
    .con-more {
      font-size: 24px;
      color: #fff;
      cursor: pointer;
      z-index: 9;
    }
  }

  // 已通过状态
  .success {
    background: #f1fcf9;
    border-color: #1ac484;
    .con-status {
      background: #fff;
      color: #1ac484;
    }
  }
  // 未通过状态
  .fail {
    background: #ffedf0;
    border-color: #ff4d64;
    .con-status {
      background: #fff;
      color: #ff4d64;
    }
  }
  // 审核状态
  .warning {
    background: #fff9e9;
    border-color: #ffb800;
    .con-status {
      background: #fff;
      color: #ffb800;
    }
  }
}
.conf-btn {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  .btn {
    min-width: 148px;
    height: 40px;
    cursor: pointer;
    font-size: 19px;
    margin: 0 10px;
    font-weight: 500;
    color: #2690e6;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #008dff;
    &:hover {
      text-decoration: underline;
    }
  }
  .next-btn {
    color: #fff;
    background: #008dff;
  }
}
@media only screen and (max-width: 767px) {
  .content {
    min-height: calc(100vh - 60px);
    padding: 0 0 130px 0;
  }
  .con-status {
    font-size: 12px !important;
  }
  .con-more {
    font-size: 20px !important;
  }
  .con-list .con-item .con-top .icon-img {
    width: 38px !important;
    height: 38px !important;
  }
  .btn {
    font-size: 15px !important;
    min-width: 130px !important;
  }
  .con-top {
    font-size: 16px !important;
  }
  .con-item {
    width: 100% !important;
    padding: 23px !important;
  }

  .con-list {
    margin: 23px 0 0;
    padding: 30px 0 120px 20px;
  }
  .conf-btn {
    bottom: 60px;
  }
}
</style>